module.exports = __webpack_public_path__ + "static/aft-8ba49c0b4d23b3668f033e9f91151fe3.png";